if (!customElements.get('floating-navigation')) {
  customElements.define(
    'floating-navigation',
    class FloatingNavigation extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-visible');
        document.body.classList.add('floating-navigation-visible');

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.updateCartCount(event));
        }
      }

      disconnectedCallback() {
        document.body.classList.remove('floating-navigation-visible');
        this.unsubscribe?.();
      }

      async updateCartCount(event) {
        let count = event?.cartData?.item_count;

        if (!Number.isFinite(count)) {
          try {
            const response = await fetch(`${window.routes.cart_url}.js`);
            if (!response.ok) return;
            count = (await response.json()).item_count;
          } catch (error) {
            return;
          }
        }

        const countElement = this.querySelector('[data-floating-cart-count]');
        const description = this.querySelector('[data-floating-cart-description]');
        if (!countElement) return;

        countElement.textContent = count > 99 ? '99+' : count;
        countElement.classList.toggle('is-empty', count === 0);
        if (description) description.textContent = `${count} item${count === 1 ? '' : 's'} in cart`;
      }
    },
  );
}
